import { checkErrors, getDefaultOptions } from "../../../services/Category";
import { GenericObject } from "../../../services/Price";

export const deleteMail = async (id: number) => {
  const response = await fetch(`/api/user/bloc-mails/${id}/`, {
    ...getDefaultOptions(),
    method: "DELETE",
  });

  checkErrors(response);

  // If delete mail
  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const updateToggleMails = async <T,>(
  url: string,
  data: T,
  options: GenericObject = {}
) => {
  const _url = new URL(`${url}`, window.origin);
  const _options = { method: "PUT", body: JSON.stringify(data), ...options };

  const response = await fetch(_url.toString(), getDefaultOptions(_options));

  checkErrors(response);

  return null;
};
